import { fetchApi } from '../utils/helpers';
import constants from '../constants';

const { FETCH_FEI_ID_REQUEST, FETCH_FEI_ID_SUCCESS, FETCH_FEI_ID_FAILURE } = constants;

/**
 * Fetch athlete
 */
export const fetchFeiIdSuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: FETCH_FEI_ID_SUCCESS,
    payload: {
      athlete: data.athlete,
    },
  });
};

export const fetchFeiIdFailure = reject => dispatch => {
  reject();

  dispatch({
    type: FETCH_FEI_ID_FAILURE,
  });
};

export const fetchFeiIdRequest = () => ({
  type: FETCH_FEI_ID_REQUEST,
});

export const fetchAthleteByFeiId = (token, feiId, type) => dispatch => {
  dispatch(fetchFeiIdRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: `/entries/feiid/${type}/${feiId}`,
      method: 'get',
      token,
      dispatch,
      cb: fetchFeiIdSuccess.bind(this, resolve),
      fb: fetchFeiIdFailure.bind(this, reject),
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/feiId.js